import { TIPTAP_ACTION_BUTTON_TYPE, TIPTAP_LINK_BUTTON_TYPE } from "./../../ricos-content";
import { createRicosNodeExtension } from "./../../plugin-commons";
import { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE } from "../types";
import { isDefined } from "../utils/isDefined";
import { Button as Component } from "./component";
const getButtonExtension = (name, disableResize) => [
  createRicosNodeExtension({
    groups: [
      "overlay",
      disableResize ? void 0 : "resizable",
      "draggable",
      "not-overtypable"
    ].filter(isDefined),
    type: "react-node",
    reconfigure: (config, _extensions, _props, settings) => ({
      ...config,
      addOptions: () => settings
    }),
    Component,
    name,
    createExtensionConfig() {
      return {
        name: this.name,
        group: "block",
        selectable: true,
        draggable: true,
        addAttributes: () => ({
          type: null,
          containerData: null,
          styles: null,
          text: null,
          link: null
        })
      };
    }
  })
];
const tiptapExtensionsMap = ({ disableResize }) => ({
  [LINK_BUTTON_TYPE]: getButtonExtension(TIPTAP_LINK_BUTTON_TYPE, disableResize),
  [ACTION_BUTTON_TYPE]: getButtonExtension(TIPTAP_ACTION_BUTTON_TYPE, disableResize)
});
export {
  tiptapExtensionsMap
};
//# sourceMappingURL=tiptap.js.map
